import cs from './index.module.scss';
import { FormattedMessage } from "react-intl";
import CommonModal from '../commonModal';
import { useStore } from '../../../models';
import { Button } from 'antd';
import { observer } from "mobx-react-lite";
import { Hooks, Util, Platform } from "@xt/xtbase";

const {useDocumentWidth} = Hooks;

const XtMessage = () => {
  const { message, consl } = useStore();
  const domeWidth = (useDocumentWidth() ?? 0) > 768

  return (
      <CommonModal
        closable={false}
        isShowModal={message.messageModalVisible && message.tip}
        width={domeWidth ? 400 : 280}
        zIndex={1299}
      >
        <div className='XtMessage'>
          <div className='tip'>
            {message.tip && <FormattedMessage id={message.tip} />}
          </div>
          <div className={cs.globalKnowBtn}>
            <Button type="primary" onClick={() => {
              message.setMessage('');
              message.setMessageModalVisible(false);
              if (message.mcSet.has('COSMOS_1012') && !Object.keys(consl.databoardOverview).length) {
                window.location.href = Platform.isInApp() ? Util.getXTUrl('/affiliate') : Util.getUrl('/affiliate');
              }
              message.clearMcSet();
            }}>
              <FormattedMessage id={'message.know'} />
            </Button>
          </div>
        </div>
      </CommonModal>
  );
};

export default observer(XtMessage);
